<template>
    <div :class="['visual-building', {'is-show': isReady}]">
        <Canvas>
            <Pointer slot="pointer"/>
            <Infrastructure slot="infrastructure"/>
            <Panorama slot="panorama"/>
        </Canvas>
        <Vr/>
        <Breadcrumbs/>
        <Rotate/>
        <Compass/>
        <Filters/>
    </div>
</template>

<style lang="scss">
    @import "./Building.scss";
</style>

<script>
import {mapActions, mapGetters} from 'vuex';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import Canvas from '../../components/Canvas/Canvas';
import Compass from '../../components/Compass/Compass';
import Filters from '../../components/Filters/Filters';
import Infrastructure from '../../components/Infrastructure/Infrastructure';
import Panorama from '../../components/Panorama/Panorama';
import Pointer from '../../components/Pointer/Pointer';
import Rotate from '../../components/Rotate/Rotate';
import store from '../../store';
import Vr from '../../components/Vr/Vr';

export default {
    components: {
        Pointer,
        Canvas,
        Infrastructure,
        Compass,
        Rotate,
        Breadcrumbs,
        Filters,
        Vr,
        Panorama
    },

    computed: {...mapGetters({isReady: 'GET_IS_READY'})},

    methods: {...mapActions(['send'])},

    beforeRouteEnter(to, from, next) {
        /**
         * Отправляет данные на сервер.
         */
        const body = {
            step   : 'building',
            complex: to.params.complexId || ''
        };

        store.dispatch('send', body).then(() => {
            if (store.getters.GET_REDIRECT) {
                next(store.getters.GET_REDIRECT);

                return;
            }
            next();
        });
    }
};
</script>
